import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { GET_CART_LINKS, GET_COLLECTION_RECORDS } from "../actions";
import centralAxios from "../../axios/centralApiAxios";

import {
  getCollectionItemRecordsSuccess,
  getCollectionItemRecordsError,
  getCartLinksSuccess,
  getCartLinksError
} from "./actions";

export function* watchGetCollectionItemRecords() {
  yield takeEvery(GET_COLLECTION_RECORDS, getCollectionItemRecordList);
}

export function* watchGetCartLinks() {
  yield takeEvery(GET_CART_LINKS, getCartLinks);
}

// eslint-disable-next-line
const getCartLinksAsync = async (payload) => {
  const recordCollectionListReturned = await centralAxios.get("designer/cart-links");
  return {
    cartLinks: recordCollectionListReturned.data,
    message: null
  };
};


function* getCartLinks({ payload }) {
  try {
    const recordListReturned = yield call(getCartLinksAsync, payload);
    if (!recordListReturned.message) {
      yield put(getCartLinksSuccess(recordListReturned.cartLinks));
    } else {
      yield put(getCartLinksError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getCartLinksError(error));
  }
}


// eslint-disable-next-line
const getCollectionRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();

  const recordCollectionListReturned = await centralAxios.get("collections?verbType=2");

  return {
    recordCollectionItemList: recordCollectionListReturned.data,
    total_item_count: recordCollectionListReturned.data.total_item_count,
    message: null,
    responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
  };
};


function* getCollectionItemRecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getCollectionRecordListAsync, payload);

    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordCollectionItemList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(
            recordListReturned.total_item_count / pageSize
          ),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getCollectionItemRecordsSuccess(recordListParam));
    } else {
      yield put(getCollectionItemRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getCollectionItemRecordsError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetCollectionItemRecords),
    fork(watchGetCartLinks)
  ]);
}
